/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ name: NonNullable<unknown> }} Share_Text_Deck_HeadingInputs */



/**
* | output |
* | --- |
* | "{name}'s deck:" |
*
* @param {Share_Text_Deck_HeadingInputs} inputs
* @param {{ locale?: "en" | "fr" | "es" | "pt" | "it" }} options
* @returns {LocalizedString}
*/
export const share_text_deck_heading = /** @type {((inputs: Share_Text_Deck_HeadingInputs, options?: { locale?: "en" | "fr" | "es" | "pt" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Share_Text_Deck_HeadingInputs, { locale?: "en" | "fr" | "es" | "pt" | "it" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ (`Deck de ${i?.name} :`)
	if (locale === "es") return /** @type {LocalizedString} */ (`Deck de ${i?.name}:`)
	if (locale === "pt") return /** @type {LocalizedString} */ (`Deck de ${i?.name}:`)
	if (locale === "it") return /** @type {LocalizedString} */ (`Deck di ${i?.name}:`)
	return /** @type {LocalizedString} */ (`${i?.name}'s deck:`)
});